import { call, put, takeLatest } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { AnnouncementAction } from "../actions";
import * as AnnouncementApi from "../api/announcement";
import { SetMessage } from "../assets/errorMessages";

export function* watcherAnnouncement() {
  yield takeLatest(types.ANNOUNCEMENT_SHOW_REQUEST, get);
}

function getReq(id) {
  return AnnouncementApi.get(id);
}

function* get(action) {
  try {
    const response = yield call(getReq, action.id);
    yield put(AnnouncementAction.getSuccess(action.id, response.data.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(AnnouncementAction.getFailure(message));
  }
}
